/**
 * Created by mathieudeumie on 30/04/2014.
 */

angular.module('FlexyBeautyApp.services').
    factory('AppAttribute',[
        function ()
        {
            var AppAttribute = function (code, value,text)
            {
                this.code = "";
                this.value = "";
                this.text = null;

                if(code !== undefined)
                    this.setValues(code, value,text);
            };

            AppAttribute.prototype.setValues = function(code, value,text)
            {
                this.code = code;
                if (value!==undefined)
                    this.value = value;
                if (text!==undefined)
                    this.text = text;
            };
            AppAttribute.prototype.setValue = function(code, value)
            {
                this.value = value;
            };
            AppAttribute.prototype.getObjectResource = function()
            {
                var newAppAttribute = new AppAttribute();

                newAppAttribute.setValues(this.code, this.value);

                return newAppAttribute;
            };
            AppAttribute.prototype.getCode = function()
            {
                return this.code;
            };
            AppAttribute.prototype.getValue = function()
            {
                return this.value;
            };

            return AppAttribute;
        }
    ]);


// WEBPACK FOOTER //
// ./js/services/models/AppAttribute.js